import React, { useEffect, useState } from 'react';
import Loading from '../../Shared/Loading/Loading';
import useAuth from '../../../hooks/useAuth';
import useUser from '../../../hooks/useUser';
import fabLogo from '../../../assets/icon.png';
import { IoLocationSharp, IoCallSharp, IoMail } from "react-icons/io5";
import { Table } from 'react-bootstrap';
import './print.css';
import { date } from '../../../hooks/helpers';
import { shopAddress, shopCategory, shopNumber, shopTitle } from '../../../configs/constants';

const PrintElement = ({ cartItems, orderConfirm, subTotal, total }) => {

    const customerId = orderConfirm.userId;

    // getting specific user by id & logged user
    const { loggedUser } = useAuth();
    const { user: customer, userLoading } = useUser(customerId);

    // get due balance
    const [newBalance, setNewBalance] = useState(customer?.user?.accountId?.balance)
    useEffect(() => {
        setNewBalance(customer?.user?.accountId?.balance + orderConfirm?.due)
    }, [customer?.user?.accountId?.balance, orderConfirm?.due])

    // loading
    if (userLoading) { return <Loading /> }

    return (

        <div className="print-container">

            <div className="invoice-header p-5">
                <div className="row">
                    <div className="col-6">
                        <div className="logo">
                            <div className="d-flex">
                                <img src={fabLogo} width={50} height={50} alt="Logo" />
                                <div className="name-title px-2">
                                    <h5 className='m-0'>{shopTitle}</h5>
                                    <p>{shopCategory}</p>
                                </div>
                            </div>


                        </div>

                    </div>
                    <div className="col-6">
                        <h5 className="">INVOICE</h5>
                        <div className="company-inforamtion">

                            <p> <span> <IoLocationSharp /></span> {shopAddress}</p>
                            <p> <span> <IoCallSharp /></span>  {shopNumber}</p>
                        </div>

                    </div>

                </div>
            </div>

            <div className="invoice_details pt-4 px-5 pb-1">
                <Table bordered>
                    <tbody>
                        <tr>
                            <td>
                                <p>Invoice to,</p>
                                <strong>{customer?.user.name} </strong>
                                <p> <IoMail /> {customer?.user.email}</p>
                                <p> <IoLocationSharp /> {customer?.user.address}</p>
                                <p> <IoCallSharp /> {customer?.user.mobile}</p>
                            </td>
                            <td>
                                <p>Invoice info</p>
                                <p>Order ID: <strong>{orderConfirm.invoiceId}</strong> </p>
                                <p>Date: {date}</p>

                                <p>Checkout by: {loggedUser?.name}</p>
                            </td>
                            <td>
                                <p>Total</p>
                                <h4>{total} BDT</h4>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>

            <div className='px-5'>
                <div className=" table-responsive my-2 ">
                    <table className="table table-bordered">
                        <tbody>
                            <tr className='csbg_secondery text-white'>
                                <th scope="col" className='font-14'>Product Name</th>
                                <th scope="col" className='font-14'>Price</th>
                                <th scope="col" className='font-14'>Quantity</th>
                                <th scope="col" className='font-14'>Total</th>
                            </tr>
                            {
                                cartItems?.cartItems.map(cartItem => <tr key={cartItem._id}>
                                    <td className='font-14'>{cartItem?.productId?.name}</td>
                                    <td className='font-14'>{cartItem?.orderPrice} BDT</td>
                                    <td className='font-14'>{cartItem?.orderQuantity} PC</td>
                                    <td className='font-14'>{cartItem?.orderPrice * cartItem?.orderQuantity} BDT</td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                </div>

                <div className='page-break' />

                <div className='d-flex justify-content-between'>
                    <div>
                        <table className="table table-bordered">
                            <tbody>

                                <tr >
                                    <td className='font-14'> Cash Received:</td>
                                    <td className='font-14'>{orderConfirm?.cash} BDT</td>
                                </tr>
                                <tr >
                                    <td className='font-14'> Due:</td>
                                    <td className='font-14'>{orderConfirm?.due} BDT</td>
                                </tr>
                                <tr >
                                    <td className='font-14'> Balance:</td>
                                    <td className='font-14'>{newBalance} BDT</td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <div>
                        <table className="table table-bordered">
                            <tbody>

                                <tr >
                                    <td className='font-14'> Subtotal</td>
                                    <td className='font-14'>{subTotal} BDT </td>
                                </tr>
                                <tr >
                                    <td className='font-14'> Labor Charge:</td>
                                    <td className='font-14'>{orderConfirm?.laborCharge} BDT</td>
                                </tr>
                                <tr >
                                    <td className='font-14'> Discount:</td>
                                    <td className='font-14'>{orderConfirm?.discount} BDT</td>
                                </tr>
                                <tr >
                                    <td className='font-14'> Total:</td>
                                    <td className='font-14'><strong>{total} BDT</strong></td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <div className="p-5"></div>

            <div className='print-footer p-2'>
                <hr className='csbg_primary' />
                <p className='my-1 text-center font-12'>Thank you for choosing our products. We believe you will be satisfied by our service</p>
                <p className='my-1 text-center font-12'>Software developed by kalaTabij. Phone: +8801689201370, +8801713644570</p>
            </div>

        </div>

    );
};

export default PrintElement;